import script from "./BaseConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./BaseConfirmationModal.vue?vue&type=style&index=0&id=08222334&lang=scss"

const __exports__ = script;

export default __exports__